import { render, staticRenderFns } from "./OrderDetail.vue?vue&type=template&id=069a1824&"
import script from "./OrderDetail.vue?vue&type=script&lang=js&"
export * from "./OrderDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\laravel\\rawal\\rawal-laravel\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('069a1824')) {
      api.createRecord('069a1824', component.options)
    } else {
      api.reload('069a1824', component.options)
    }
    module.hot.accept("./OrderDetail.vue?vue&type=template&id=069a1824&", function () {
      api.rerender('069a1824', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/OrderDetail.vue"
export default component.exports